import { atom } from 'recoil';

export const SENDER_TYPE_ROOM = 'ROOM_AREA';
export const SENDER_TYPE_HOTEL = 'HOTEL_AREA';

export const INTERPHONE_CANCEL_TYPE_TIMEOUT = 'SENDER_TIMEOUT';
export const INTERPHONE_CANCEL_TYPE_SENDER = 'SENDER_CANCEL';
export const INTERPHONE_CANCEL_TYPE_RECEIVER = 'RECEIVER_CANCEL';

export const INTERPHONE_STATUS_NONE = 0;
export const INTERPHONE_STATUS_SENDER_WAIT = 1;
export const INTERPHONE_STATUS_RECEIVER_WAIT = 2;
export const INTERPHONE_STATUS_CALLING = 3;
export const INTERPHONE_STATUS_CANCEL = 4;
export const INTERPHONE_STATUS_CONNECTING_WAIT = 5;

// export type ReceivedAreaType = {
//   sender: string;
//   room_area_name: string;
//   hotel_area_name: string;
// };

export const areaState = atom<string | null>({
  key: 'area',
  default: null,
});
